import { render } from "./m_Register.vue?vue&type=template&id=6a47542a&scoped=true"
import script from "./m_Register.vue?vue&type=script&lang=js"
export * from "./m_Register.vue?vue&type=script&lang=js"

import "./m_Register.vue?vue&type=style&index=0&id=6a47542a&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a47542a"]])

export default __exports__